webpackJsonp([221374088121123],{

/***/ 155:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var gatsby_link_1 = __webpack_require__(152);
	exports.SectionTile = function (props) {
	    return React.createElement("div", { className: "col-lg-4 col-md-6" }, React.createElement(gatsby_link_1.default, { to: props.link }, React.createElement("img", { src: props.image }), React.createElement("h3", null, props.title)));
	};
	exports.default = exports.SectionTile;

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/achievement-agreement-arms-1068523.2936edcf.jpg";

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/code-coding-computer-34676.a749dc56.jpg";

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var section_tile_1 = __webpack_require__(200);
	
	var default_1 = function (_React$Component) {
	    _inherits(default_1, _React$Component);
	
	    function default_1(props, context) {
	        _classCallCheck(this, default_1);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	    }
	
	    default_1.prototype.render = function render() {
	        return React.createElement("div", null, React.createElement("h1", null, "Welcome"), React.createElement("div", { className: "primary-text-color" }, React.createElement("div", null, "How often have you had this frustrating conversation with your mentees?"), React.createElement("br", null), React.createElement("div", null, "Q: \"What would you like to learn about? What are your interests? How would you like me to help you grow?\""), React.createElement("div", null, "A: \"I dunno, I want you to help me be better at my job\""), React.createElement("br", null), React.createElement("div", null, "This certainly isn't uncommon and quite often the result is a few unstructured catch-ups with a some talks about a pairing session later on or a task to complete before the next meeting that you found 5 minutes beforehand in a quick google search of: 'x framework tutorial'. This can leave mentors feeling both overwhelemed and unqualified."), React.createElement("div", null, "Both new and old mentors have the same issues with deciding on how to approach a mentees study. To solve this we've come together to provide you and your mentee(s) free programs that provide both a problem for you both to work through and instruction on what you as a mentor should come to expect from each step."), React.createElement("br", null), React.createElement("div", null, "For now we only have a section for developers but if you think this style of course is applicable to your profession or discipline, please reach out.")), React.createElement("br", null), React.createElement("br", null), React.createElement("div", { className: "container-fluid" }, React.createElement("div", { className: "row" }, React.createElement(section_tile_1.SectionTile, { link: "/developers/", title: "Mentoring: Developers", image: __webpack_require__(457) }), React.createElement(section_tile_1.SectionTile, { link: "/contributors/", title: "Contributors", image: __webpack_require__(456) }))));
	    };
	
	    return default_1;
	}(React.Component);
	
	exports.default = default_1;
	exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-tsx-83081a61398344314bc4.js